import { createFileRoute } from '@tanstack/react-router';

import { contentRouteOptions } from '@/lib/content-route';

export const Route = createFileRoute('/abilities/')(
  contentRouteOptions('/abilities')
);
